import { PermissionKey } from "./permissions";
import { Role } from "./roles";
import { ROLE_PERMISSIONS } from "./roleCapabilities";

export { PERMISSIONS } from "./permissions";
export type { PermissionKey } from "./permissions";
export { ROLE, ROLES, ROLE_METADATA, isExternalRole } from "./roles";
export type { Role } from "./roles";
export { ROLE_PERMISSIONS } from "./roleCapabilities";
export { WORKLIST_TAB_KEYS, WORKLIST_TAB_PERMISSIONS, getVisibleWorklistTabKeys } from "./worklistTabs";
export type { WorklistTabKey } from "./worklistTabs";

/**
 * Plain (non-hook) permission check, usable outside React - thunks, route
 * configs, or any other non-component code that today reaches for rbac.js's
 * checkers or a raw role-string comparison instead of a hook. Fails closed
 * on an unrecognized role (`?? []`), unlike rbac.js's `undefined?.indexOf(x)
 * !== -1` pattern, which failed OPEN (Tier 0 #1).
 *
 * `src/hooks/usePermissions.ts` wraps this for component use.
 */
export const hasPermission = (role: Role | string | undefined | null, permission?: PermissionKey): boolean => {
  if (!permission) return true;
  const permissions = ROLE_PERMISSIONS[role as Role] ?? [];
  return permissions.includes(permission);
};
